import React from 'react';
import { Icon, IconColor, IconProps } from '@doveit/bricks';
import { Aggregator, AggregatorStatus } from '../../../domain/types';
import { aggregatorIcons, aggregatorLabels } from '../../constants';

export interface PublishedOnStatusIconProps {
  aggregator: Aggregator,
  status?: AggregatorStatus | 'NOT_PUBLISHED',
  url?: string,
  size?: IconProps['size'],
  onClick?: VoidFunction,
}

const PublishedOnStatusIcon: React.FC<PublishedOnStatusIconProps> = ({
  aggregator,
  status = 'NOT_PUBLISHED',
  url,
  size,
  onClick,
}) => {
  const color: IconColor = React.useMemo(() => {
    if (status === AggregatorStatus.ERROR) return 'critical.default.low';

    if (status === AggregatorStatus.SUCCESS) {
      if (!url) return 'neutral.default.highest';

      return 'primary.default.low';
    }

    return 'neutral.disabled.low';
  }, [status, url]);

  return (
    <div
      aria-label={`Aggregatore ${aggregatorLabels[aggregator]}`}
      title={`${status === AggregatorStatus.SUCCESS ? 'Pubblicato su ' : ''}${aggregatorLabels[aggregator]}`}
    >
      <Icon
        path={aggregatorIcons[aggregator]}
        size={size}
        color={color}
        onClick={onClick}
      />
    </div>
  );
};

export default PublishedOnStatusIcon;
